import { ChangeDetectorRef, Component, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FilmServiceService } from 'src/app/core/services/contest and drawing/film-service.service';
import { StarRatingColor } from '../star-rate/star-rate.component';
import { error } from 'console';

@Component({
  selector: 'app-pickscore',
  templateUrl: './pickscore.component.html',
  styleUrls: ['./pickscore.component.css']
})
export class PickscoreComponent implements OnInit {

  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;
 
  [x: string]: any;
   
    constructor(private service: FilmServiceService, private sanitizer: DomSanitizer,private activatedRoute: ActivatedRoute,
      private  dialog : MatDialog,private router: Router, private cdRef: ChangeDetectorRef) {}
    
    desc: any;
    movieId: number
    
    carouselOptions = {
      loop: false,
      items: 4,
      dots: false,
      nav: true,
      navText: ["<i class='bi bi-caret-left-fill'></i>", "<i class='bi bi-caret-right-fill'></i>"],
      autoplay: false,
      autoplayTimeout: 4000,
      slideBy: 4,
      responsive: {
        0: {
          items: 1,
          slideBy: 1,
          margin: 10
        },
        499: {
          items: 2,
          slideBy: 2,
          margin: 20
        },
        768: {
          items: 3,
          slideBy: 3,
          margin: 20
        },
        940: {
          items: 3,
          slideBy: 3,
          margin: 20
        },
        1200: {
          items: 4,
          slideBy: 4,
          margin: 20
        },
        1800: {
          items: 6,
          slideBy: 6,
          margin: 20
        }
      }
    };

    treasuryOptions = {
      loop: false, 
      dots: false,
      nav: true,
      navText: ["<i class='bi bi-caret-left-fill'></i>", "<i class='bi bi-caret-right-fill'></i>"],
      autoplay: false,
      autoplayTimeout: 4000,
      slideBy: 4,
      responsive: {
        0: {
          items: 1,
          slideBy: 1,
          margin: 10
        },
        499: {
          items: 2,
          slideBy: 2,
          margin: 20
        },
        768: {
          items: 3,
          slideBy: 3,
          margin: 20
        },
        940: {
          items: 3,
          slideBy: 3,
          margin: 20
        },
        1200: {
          items: 4,
          slideBy: 4,
          margin: 20
        },
        1800: {
          items: 6,
          slideBy: 6,
          margin: 20
        }
      }
    };


    profilePic: any[] = [];
    data: any[] = [];
    backgroundImg: any;
   
    // Calculate the middle index based on the length of the array
  middleIndex: number = Math.floor(this.profilePic.length / 2);
  selectedProfileVideoUrl: SafeResourceUrl;
  aboutDesc: any;
  isVideo: number | null = 0;
  contestId:number;
  showShortDescription = true
  titleHead:any;
  smallDesc:any;
  type:any;
  contId:number;
  starRating = 0; 
  rating:number = 0;
  starCount:number = 5;
    starColor:StarRatingColor = StarRatingColor.accent;
    starColorP:StarRatingColor = StarRatingColor.primary;
    starColorW:StarRatingColor = StarRatingColor.warn;

   openDialog(details:any) {
      const dialogRef = this.dialog.open(this.dialogTemplate, {
        data: {
          showDescription : details.profileDesc
        }
      });
   }
   
    ngOnInit(): void {

      this.contestId = this.activatedRoute.snapshot.params['id'];
      this.contId=this.contestId;
      this.service.getFansDetails(this.contestId).subscribe((res:any)=>{
        this.type=res.name
        this.movieId = res.movieId
        this.backgroundImg = res.backGroundImageUrl;
        this.desc = res.votingDescription;        //description of what you do
       this.titleHead= res.descriptionHeading;
       this.smallDesc= res.smallDescription;
        this.aboutDesc = res.largeDescription;
        this.profilePic = [...res.contestants]    //profile pic of user
        this.profilePic.forEach((response => {
          response.profileVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.profileVideoUrl)
        }))
        this.data = [...res.contestRecommendations];
        this.rating=this.profilePic[this.isVideo]?.rating;
        this.router.navigate(['/contest/'+ this.type.replace(/ /g,'-') +'/'+ this.contestId +'/'+ this.titleHead.replace(/ /g,'-')],{ replaceUrl: true });
      })
    
    }
    recommedImg(id:any){

this.router.navigateByUrl(`/contest/` + id).then(()=>{
  window.location.reload();

});

    }

    onVideoSelect(index: number) {
      this.isVideo = index;  // Ensure correct index is assigned
      this.cdRef.detectChanges();
    }    

    onRatingChanged(rating) {
     
      this.rating = rating;
      let id = this.profilePic[this.isVideo]?.competitorId;
  
      let payLoad = {
        competitorId: id,
        contestId: this.contestId,
        rating: this.rating
      };
        
      this.service.putVoting(payLoad).subscribe(res => {
        this.rating = res.rating; 
        this.cdRef.detectChanges(); 
      });
    
      let payLoad2 = {
        contestId: this.contId,
        competitorId: id
      };    
      this.service.postUpvote(payLoad2).subscribe(res => {
        if(res){
          alert("Congratulations, you got 5 currency points for rating the contestant.");
        }
      });
      this.profilePic[this.isVideo].rating = rating;
      this.rating = rating;
      this.cdRef.detectChanges();
    }
  
    getNumberOfItems(): number {
      const numberOfItems = this.profilePic.length;
      return numberOfItems;
    }
   
    getImageUrl(index: number): string {
      return this.profilePic[index].profilePicUrl;
    }

    onChange(index: number) {
      this.isVideo = index;
      this.rating = this.profilePic[this.isVideo]?.rating;
      this.cdRef.detectChanges();
    }
   
    sanitizeUrl(url: string): any {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    
    onSlideChange(event: any) {
    
      if (!event || event.startPosition === undefined || !this.profilePic.length) {
        return;
      }
    
      const currentIndex = event.startPosition;
    
      if (this.getNumberOfImageItems() === 1) { 
        this.isVideo = currentIndex;
        this.rating = this.profilePic[currentIndex]?.rating || 0;
        this.cdRef.detectChanges();
      }
    }

    getNumberOfImageItems(): number {
      return window.innerWidth <= 480 ? 1 : 4;
    }

    getStageDetails(stage: any, event: Event) {
      event.preventDefault();
      if(stage ==='casting'){
      this.router.navigate(['/hitmaker/' + this.movieId + '/stage/' + stage]);
      }
    }
    
}
